import { useState } from "react"
import { IconChevronDownOutline18 as ChevronDown } from "nucleo-ui-outline-18"

import { cn } from "@productlane/lib/src/cn"

/** The tool's own description, folded away when it runs long. */
export function ToolDescription({ text }: { text: string }) {
	const [expanded, setExpanded] = useState(false)

	if (!text) return null

	const foldable = text.length > 160 || text.includes("\n")

	const description = (
		<p
			className={
				expanded
					? "max-h-40 overflow-y-auto whitespace-pre-line pb-2 text-xs text-tertiary"
					: "max-h-12 overflow-hidden whitespace-pre-line text-xs text-tertiary [mask-image:linear-gradient(to_bottom,black_62%,transparent_100%)]"
			}
			data-testid="tool-description"
		>
			{text}
		</p>
	)

	if (!foldable) return <div className="space-y-0.5">{description}</div>

	const chevron = (
		<ChevronDown
			className={cn(
				"h-3.5 w-3.5 flex-none text-tertiary transition-transform duration-200 ease-out group-hover:text-primary",
				expanded && "rotate-180",
			)}
		/>
	)

	// Collapsed, the whole box opens it; expanded, only the chevron row closes it
	// again, so selecting the text does not fold it away mid-read.
	if (!expanded) {
		return (
			<button
				type="button"
				aria-label="Show more"
				className="group block w-full cursor-default space-y-0.5 py-1 text-left"
				onClick={() => setExpanded(true)}
			>
				{description}
				<span className="flex justify-center">{chevron}</span>
			</button>
		)
	}

	return (
		<div className="space-y-0.5 py-1">
			{description}
			<button
				type="button"
				aria-label="Show less"
				className="group flex w-full cursor-default justify-center"
				onClick={() => setExpanded(false)}
			>
				{chevron}
			</button>
		</div>
	)
}
